<!-- prettier-ignore -->

<button class="chat__button" type="button">
  <ci-icon name="loader-debounce" scale="1x"></ci-icon>
</button>
